<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="700px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="addButton"
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar preposto</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >{{formData.id ? 'Editar preposto' : 'Novo preposto'}}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-form ref="prepositoryForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md pl-1>
            <v-layout wrap>
              <v-flex xs8>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.representative_name"
                  label="Nome completo"
                  :rules="$store.state.formRules.required"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pl-3>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.representative_cpf"
                  label="CPF"
                  mask="###.###.###-##"
                  :rules="$store.state.formRules.required"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.representative_tell"
                  label="Telefone"
                  :mask="formData.representative_tell.length < 15 ? '(##) ####-#####' : '(##) #####-####'"
                  :rules="$store.state.formRules.required"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pl-3>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.representative_email"
                  label="Email"
                  :rules="$store.state.formRules.emailRules"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultForm = {
  representative_name: '',
  representative_tell: '',
  representative_cpf: '',
  representative_email: ''
}
export default {
  components: {},
  props: {
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    savePrepository: Function,
    dialog: Boolean,
    editFormData: Object
  },
  data: function () {
    return {
      viewForm: false,
      permissionsList: [],
      formData: { ...defaultForm },
      validForm: true
    }
  },
  computed: {
    dialogShow () {
      return this.dialog
    }
  },
  watch: {
    dialogShow: function (val) {
      if (val) {
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true
          } else {
            this.viewForm = false
          }
          this.formData = {
            ...this.editFormData
          }
        }
      } else {
        this.viewForm = false
        this.$refs.prepositoryForm.resetValidation()
        this.formData = { ...defaultForm }
      }
    }
  },
  mounted () {
    // this.getPermissions();
  },
  methods: {
    // getPermissions() {
    //   let obj = {
    //     url: "/api/permission",
    //     query: "",
    //     method: "get",
    //     noLoader: true
    //   };
    //   this.$store.dispatch("request/doRequest", obj).then(response => {
    //     this.permissionsList = response.data;
    //   });
    // },
    resetDialog () {
      this.$props.closeForm()
    },
    doSave () {
      if (!this.$refs.prepositoryForm.validate()) {
        return
      }
      // if (!this.formData.permissions_id.length) {
      //   let title = document.querySelector(".permissionTitle");
      //   title.classList.add("red--text");
      //   setTimeout(function() {
      //     title.classList.remove("red--text");
      //   }, 3000);
      //   return;
      // }
      const callback = function () {
        this.$props.closeForm()
      }
      this.$props.savePrepository(this.formData, callback)
    }
  }
}
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
</style>
